import Installation from './01.installation';
import Domain from './02.domain';

const Y11 = [
    Installation,
    ...Domain
];

export default Y11;